import Rete from "rete";
import { NumberSocket } from "../../rete-controls/NumberControl.js";
import { ArraySocket } from "../../../Utils/CommonSockets.js";
import {ToggleSocket } from "../../rete-controls/ToggleControl.js"
import { ResetSocket } from "../../rete-controls/ResetControl.js";
import { EventBus } from '../../../event-bus.js';
import { ProgressControl } from "../../rete-controls/ProgressControl";

export default class NumberArrayToStream extends Rete.Component {
  constructor() {
    super("Number Stream"); // name
    this._categories = ["Simulator"];
    this._counter = 0;
    this._currentConnectedInput = null;
    this._lastValue = null;
    this._lastIndex = null;
    this.resetConnected = false;
    this._percentage = 0;
    EventBus.$on('global-reset-nodes', x => {
      this.doResetNode();
  });
  }

  builder(node) {
    let inp1 = new Rete.Input("in1", "On/Off (Toggle)", ToggleSocket);
    let inp2 = new Rete.Input("in2", "Number Array", ArraySocket);
    var inp3 = new Rete.Input('resetIn','Reset',ResetSocket);

    let out1 = new Rete.Output("out1", "Number", NumberSocket);
    let out2 = new Rete.Output("out2", "Index", NumberSocket);
   
    let contrl1 = new ProgressControl(this.editor,"progress");

    return node.addInput(inp1).addInput(inp2).addInput(inp3)
    .addOutput(out1).addOutput(out2)
    .addControl(contrl1); 
  }
  doResetNode(){
    this._counter = 0;
    this._currentConnectedInput = null;
    this._lastValue = null;
    this._lastIndex = null;   
    this._percentage = 0;
  }
  resetNode(in3, node){

    if(node.inputs["resetIn"].connections[0] != null)
          if(in3 !== null && in3 !== undefined )this.doResetNode();
  }
  updateProgress(node){
    this.editor.nodes
    .find(n => n.id == node.id)
    .controls.get("progress")
    .setValue(this._percentage);
  }
  worker(node, inputs, outputs) {
    this.resetNode(inputs["resetIn"][0], node);
    let in1 = inputs["in1"];
    let in2 = inputs["in2"][0];

    let arrayValue = [];
    if (in2 != [] && in2 !== undefined) {
      let newConnection = node.inputs["in2"].connections[0];
      if(this._currentConnectedInput !=null){
        if(newConnection.node !== this._currentConnectedInput.node ||
          newConnection.output !== this._currentConnectedInput.output){
            this._currentConnectedInput = newConnection; 
            this._counter = 0;
            this._lastValue = null;
          }      
      }else{
        this._currentConnectedInput = newConnection; 
        this._counter = 0;
        this._lastValue = null;
        this._lastIndex = null;
      }
      arrayValue = in2;
      
    } else {
      this._currentConnectedInput =null;
      outputs["out1"] = null;
      outputs["out2"] = null ;  
      return;
    }

    // if( in1.length === 0 || in1[0] === false){
    //   if (node.outputs["out1"].connections.length > 0 && this._lastValue != null){
    //     outputs["out1"] = this._lastValue;        
    //     outputs["out2"] = this._lastIndex ;
    //   }
    //   return;
    // }

    if (node.outputs["out1"].connections.length > 0) {
      let updateCounter = false;
      if(this._counter  < arrayValue.length){
        this._lastValue = arrayValue[this._counter];
        outputs["out1"] = this._lastValue;
        updateCounter = true;
      }
      if (updateCounter && node.outputs["out2"].connections.length > 0) {
          this._lastIndex  = this._counter;     
          outputs["out2"] = this._lastIndex ; 
      } 


      if(updateCounter) this._counter = this._counter + 1;
      var currentPercentage  = Math.floor(((this._counter/arrayValue.length) * 100)/5) *5;

      if(this._percentage !== currentPercentage)
      this._percentage =  currentPercentage ;
    }
    this.updateProgress(node);
  }
}
